import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

function pageHome() {
    let pathWrp = document.querySelector('.path-line-wrp')
    let path = pathWrp.querySelector('path')
    let pathLength = path.getTotalLength()
    let pathOffset = 11950

    setPath()
    homeHeroAnim()
    homeScrollAnim()

    function setPath() {
        path.style.strokeDasharray = pathLength
        path.style.strokeDashoffset = pathLength
        path.style.transitionDuration = '0s'
        path.style.transitionTimingFunction = 'ease-out'
    }

    function homeHeroAnim() {
        let container = document.querySelectorAll('.s-hero.home-hero')
        container.forEach(container => {
            let bg = container.querySelector('.home--hero__bg-wrp')
            let elements = container.querySelectorAll('.home--hero__anim-el')
            let master = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: 'top top+=1px'
                },
                defaults: {
                    duration: 0.8,
                    ease: 'power3.out'
                }

            })

            master
                .from(bg, { opacity: 0, duration: 2 })
                .from(elements, { opacity: 0, y: '2em', stagger: 0.3 }, '<+-25%')
                .add(function () {
                    console.log(path)
                    path.style.transitionDuration = '0.6s'
                    path.style.strokeDashoffset = pathOffset
                }, '<+=0.5')
        })
    }

    function homeScrollAnim() {
        path.style.transitionDuration = '0.3s'
        ScrollTrigger.create({
            trigger: path,
            start: 'top top+=300px',
            end: 'bottom bottom-=200px',
            scrub: 1,
            onUpdate: function (tween) {
                path.style.strokeDashoffset = `${pathOffset - pathLength * tween.progress}`
            }
        })
    }

}

export default pageHome